<template>
  <div id="contenedor-contratos-estatus-toolbar">
    <v-toolbar flat dense>
      <div style="width: 350px" class="mr-2">
        <custom-text-field
        label="Buscar..."
        append-icon="mdi-magnify"
        clearable
        @keyup="buscar"
        @click:clear="limpiarBuscadorTexto">
      </custom-text-field>
      </div>
      <!-- <filtros></filtros> -->
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Nuevo"
        iconText="mdi-plus"
        tipo="agregar"
        @click="nuevo"
      >
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';

export default {
  name: 'ToolBarContratosEstatus',
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
    CustomTextField,
  },
  data() {
    return {
      debounce: null,
    };
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
    nuevo() {
      this.$emit('nuevoContratoEstatus');
    },
  },
};
</script>

<style lang="scss">
</style>
